import { render, staticRenderFns } from "./appBtn.vue?vue&type=template&id=127538fe&scoped=true&"
import script from "./appBtn.vue?vue&type=script&lang=js&"
export * from "./appBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127538fe",
  null
  
)

export default component.exports